module.exports = __webpack_public_path__ + "assets/img/title1-a7a32e5c.png";